import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createNewPurchase = async (values, callback) => {
    const res = await axios.post(`/purchase/createpurchase`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const updatePurchase = async (id, values, callback) => {
    const res = await axios.put(`/purchase/updatepurchase/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const deletePurchase = async (id, values, callback) => {
    const res = await axios.put(`/purchase/deletepurchase/${id}`, { updatedBy: values });

    if (res.status === 200) {
        callback(res.data.response)
    } else {
        callback(res.data.response)
    }
}

export const getAllPurchase = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/purchase/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

    if (res.status === 200) {
        const purchaseList = res.data.response;
        callback(purchaseList)
    } else {
        callback(res.data.response)
    }
}

export const getPurchaseById = async (id, callback) => {
    await axios.get(`/purchase/${id}`).then(res => {
        if (res.status === 200) {
            callback(res.data.response.data)
        } else {
            callback(res.data.response.data)
        }
    })
}

export const getTodayPurchase = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/purchase/todaypurchase/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`)

    if (res.status === 200) {
        callback(res.data.response)
    } else {
        callback(res.data.response)
    }
}

export const getPurchaseByDate = async (rowPerPage, pageNumber, startdate, enddate, callback) => {
    const res = await axios.get(`/purchase/bydatepurchase/${startdate}&${enddate}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`)

    if (res.status === 200) {
        callback(res.data.response)
    } else {
        callback(res.data.response)
    }
}

export const PurchaseAPI = () => {
    const [purchases, setPurchases] = useState([]);
    const [purchaseDetail, setPurchaseDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [id, setId] = useState(0);

    useEffect(() => {
        getAllPurchase(rowPerPage, pageNumber, search, res => {
            setPurchases(res);
            setTotalPages(res.totalPages || 1)
        })

        getPurchaseById(id, res => {
            setPurchaseDetail(res)
        })
    }, [callback, rowPerPage, search, pageNumber, id])

    return {
        purchases: [purchases, setPurchases],
        purchaseDetail: [purchaseDetail, setPurchaseDetail],
        id: [id, setId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }

}
